const AUTH_STORAGE_KEY = "pm-authenticated";

export const getSavedAuth = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  return window.localStorage.getItem(AUTH_STORAGE_KEY) === "true";
};

export const saveAuth = (value: boolean): void => {
  if (typeof window === "undefined") {
    return;
  }
  if (value) {
    window.localStorage.setItem(AUTH_STORAGE_KEY, "true");
  } else {
    window.localStorage.removeItem(AUTH_STORAGE_KEY);
  }
};

export const clearAuth = (): void => {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.removeItem(AUTH_STORAGE_KEY);
};
